import { createApp} from "vue";
import App from "./AppPost.vue";
document.addEventListener("DOMContentLoaded", () => {
  const postArea = document.getElementById('js-app');
  if (postArea) {
    const app = createApp(App);
    app.provide('postId', Number(postArea.dataset.postId));
    app.provide('userId', Number(postArea.dataset.userId));
    app.mount(postArea);
  }
});
